export const APPLICATION_CHAT_CONTROLS_SCHEMA = 'animus.chat.application_controls.v1' as const
export const APPLICATION_CHAT_CONTROL_REF_RE = /^(?!.*\.\.)[A-Za-z0-9][A-Za-z0-9._-]{0,63}$/

export interface ApplicationChatControlsWire {
  schema: typeof APPLICATION_CHAT_CONTROLS_SCHEMA
  approvals?: boolean
  reasoning_effort?: 'low' | 'medium' | 'high'
  permission_intent?: 'default' | 'review' | 'auto_edit' | 'unrestricted'
  profile_ref?: string
  skill_ref?: string
}

/** Canonical closed parser shared by the browser and same-origin BFF. */
export function normalizeApplicationChatControls(value: unknown): ApplicationChatControlsWire | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null
  const source = value as Record<string, unknown>
  if (
    source.schema !== APPLICATION_CHAT_CONTROLS_SCHEMA ||
    Object.keys(source).some((key) => ![
      'schema', 'approvals', 'reasoning_effort', 'permission_intent', 'profile_ref', 'skill_ref',
    ].includes(key)) ||
    (source.approvals !== undefined && typeof source.approvals !== 'boolean') ||
    (source.reasoning_effort !== undefined && (
      typeof source.reasoning_effort !== 'string' ||
      !['low', 'medium', 'high'].includes(source.reasoning_effort)
    )) ||
    (source.permission_intent !== undefined && (
      typeof source.permission_intent !== 'string' ||
      !['default', 'review', 'auto_edit', 'unrestricted'].includes(source.permission_intent)
    )) ||
    (source.profile_ref !== undefined && (
      typeof source.profile_ref !== 'string' || !APPLICATION_CHAT_CONTROL_REF_RE.test(source.profile_ref)
    )) ||
    (source.skill_ref !== undefined && (
      typeof source.skill_ref !== 'string' || !APPLICATION_CHAT_CONTROL_REF_RE.test(source.skill_ref)
    ))
  ) return null
  const normalized: ApplicationChatControlsWire = {
    schema: APPLICATION_CHAT_CONTROLS_SCHEMA,
    ...(typeof source.approvals === 'boolean' ? { approvals: source.approvals } : {}),
    ...(typeof source.reasoning_effort === 'string'
      ? { reasoning_effort: source.reasoning_effort as ApplicationChatControlsWire['reasoning_effort'] } : {}),
    ...(typeof source.permission_intent === 'string'
      ? { permission_intent: source.permission_intent as ApplicationChatControlsWire['permission_intent'] } : {}),
    ...(typeof source.profile_ref === 'string' ? { profile_ref: source.profile_ref } : {}),
    ...(typeof source.skill_ref === 'string' ? { skill_ref: source.skill_ref } : {}),
  }
  return new TextEncoder().encode(JSON.stringify(normalized)).byteLength <= 2_048
    ? normalized
    : null
}
